export const COLLECTIONS = {
  CUSTOMERS: 'customerList',
  OPERATORS: 'operators',
  PUANTAJLAR: 'puantajlar',
  MACHINES: 'machines',
  BANKS: 'banks'
};

export const CUSTOMER_STATUS = {
  PENDING: 'Onay Bekliyor',
  APPROVED: 'Onaylandı',
  WAITING: 'Beklemede'
};

export const COLLECTION_PATHS = {
  USER_CUSTOMERS: (userEmail) => `users/${userEmail}/customerList`,
  USER_OPERATORS: (userEmail) => `users/${userEmail}/operators`,
  USER_MACHINES: (userEmail) => `users/${userEmail}/machines`
}; 